"use client";
import React, { memo } from "react";
import { Button, ButtonProps, Typography } from "@mui/material";
import { FilterIcon } from "@/icons";

const AppToggleFilterButton = ({
  isShowFilter,
  hiddenLabel = "Ẩn bộ lọc",
  showLabel = "Hiện bộ lọc",
  ...otherProps
}: AppToggleFilterButtonProps) => {
  return (
    <Button
      startIcon={<FilterIcon sx={{ fontSize: "16px !important" }} />}
      variant="outlined"
      color={isShowFilter ? "primary" : "secondary"}
      sx={{
        width: "130px",
        justifyContent: "flex-start",
        padding: "10.75px 14px",
        backgroundColor: "common.white",
      }}
      {...otherProps}
    >
      <Typography whiteSpace={"nowrap"}>
        {isShowFilter ? hiddenLabel : showLabel}
      </Typography>
    </Button>
  );
};

type AppToggleFilterButtonProps = ButtonProps & {
  isShowFilter: boolean;
  hiddenLabel?: string;
  showLabel?: string;
};

export default memo(AppToggleFilterButton);
